// extracted by mini-css-extract-plugin
export default {"wrapper":"TestCategories_wrapper__uPlyv","row":"TestCategories_row__soEej","btn":"TestCategories_btn__r-gQI","empty":"TestCategories_empty__XtJCJ"};